import styled from 'styled-components';
import { Button } from '@salutejs/sdds-insol';
import { useModalStore } from '@/entities/Modal';
import { Typography } from '@/shared/ui/Typography';
import Logo from '@/shared/assets/lk/lkLogo.svg?react';
import { ModalWrapper } from '@/shared/ui/ModalWrapper';
import cls from './GoalChosenModal.module.scss';

const StyledButton = styled(Button)`
    background-color: #333f48;
`;

export const GoalChosenModal = () => {
    const { isGoalChosenModalOpen, setIsGoalChosenModalOpen } = useModalStore();

    return (
        <ModalWrapper id="goalChosenModal" isOpened={isGoalChosenModalOpen} setIsOpened={setIsGoalChosenModalOpen}>
            <div className={cls.container}>
                <Logo className={cls.logo} />
                <Typography className={cls.title} as="h5" variant="h5_bold">
                    Цель успешно добавлена
                </Typography>
                <StyledButton
                    className={cls.button}
                    size="xl"
                    view="dark"
                    type="submit"
                    stretch
                    onClick={() => {
                        setIsGoalChosenModalOpen(false);
                    }}
                >
                    <span className="SBSansText">Понятно</span>
                </StyledButton>
            </div>
        </ModalWrapper>
    );
};
